// extracted by mini-css-extract-plugin
module.exports = {"toggleSideBar":"ToggleSideBarButton_toggleSideBar__14AcP","black":"ToggleSideBarButton_black__2kqEb"};